import './index.css';

function Head() {
  return (
    <>
    <nav  className="navbar navbar-expand-lg bg-body-tertiary">
    <div  className="container-fluid">
        <a  className="navbar-brand" href="#">Portfolio</a>
        <button  className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span  className="navbar-toggler-icon"></span>
        </button>
        <div  className="collapse navbar-collapse" id="navbarNav">
            <ul  className="navbar-nav">
                <li  className="nav-item">
                    <a  className="nav-link active" aria-current="page" href="index.html">Home</a>
                </li>
                <li  className="nav-item">
                    <a  className="nav-link" href="Resume.pdf">My Resume</a>
                </li>
                <li  className="nav-item">
                    <a  className="nav-link" href="#">Contact</a>
                </li>
            </ul>
            
        </div>
    </div>
</nav>
  
  </>
  );
}

export default Head;
